import { IRM_PERMISSION_ID, WEBCAST_PERMISSION_ID } from '@/config/environment';
import { MyCompaniesResponse } from '@/features/login/api/getMyCompanies';

type Company = MyCompaniesResponse['data'][0];

const hasPermission = (company: Company, permissionId: string) =>
  !!company.userCompanyRoles
    ?.at(0)
    ?.role.permissions.some((permission) => permission.id === permissionId);

// A company opens the home (which redirects to the person's starting page) when they can use
// IRM, Webcast or AI; anything else goes to "Demais Serviços". The AI module has no permission of
// its own: it relies on the IRM permission, plus the company `tool.ai` flag.
export const hasHomeAccess = (company: Company | undefined) =>
  !!company &&
  ((!!company.tool?.irm && hasPermission(company, IRM_PERMISSION_ID)) ||
    (!!company.tool?.webcast && hasPermission(company, WEBCAST_PERMISSION_ID)) ||
    (!!company.tool?.ai && hasPermission(company, IRM_PERMISSION_ID)));
